import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem, FormControlLabel, Checkbox, Divider, Button, IconButton, FormHelperText } from '@material-ui/core';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import { INDENTIDAD_GENERO_BIENESTAR } from '../../../helper';
import { cargarCatalogo } from '../../components/CargarCatalogoBienestar';

/* =======================
    STEP 1 — Identificación y Decisión
   ======================= */
function IdentificacionDecision({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const mostrarRestoDelFormato = safeValue('voluntad_restaurativa') === 'SI';
    const [identidadGenero, setIdentidadGenero] = useState([]);


    useEffect(() => {

            if (solicitud?.usuario_registro) {
    
                const usuario = solicitud.usuario_registro;
    
                const nombreCompleto = `
                    ${usuario.primer_nombre || ''} 
                    ${usuario.segundo_nombre || ''} 
                    ${usuario.primer_apellido || ''} 
                    ${usuario.segundo_apellido || ''}
                `.replace(/\s+/g, ' ').trim();

                onChange({
                    target: {
                        name: 'nombre_afectado',
                        value: nombreCompleto
                    }
                });
    
                onChange({
                    target: {
                        name: 'documento_identidad',
                        value: usuario.identificacion || ''
                    }
                });

                onChange({
                    target: {
                        name: 'numero_contacto',
                        value: usuario.celular || usuario.telefono || ''
                    }
                });

                onChange({
                    target: {
                        name: 'correo',
                        value: usuario.correo_personal || ''
                    }
                });
            }
                const cargarTodo = async () => {
                    await Promise.all([
                        cargarCatalogo(INDENTIDAD_GENERO_BIENESTAR, setIdentidadGenero),
                    ]);
                };
                    cargarTodo();
        }, [solicitud]);


    return (
        <Grid container spacing={3}>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre de la persona afectada"
                    name="nombre_afectado"
                    value={safeValue('nombre_afectado')}
                    onChange={onChange}
                    error={!!safeError('nombre_afectado')}
                    helperText={safeError('nombre_afectado')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="No. de documento de Identidad"
                    name="documento_identidad" // Coincide con el backend
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={!!safeError('documento_identidad')}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Lugar de expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={!!safeError('lugar_expedicion')}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label="Edad"
                    name="edad"
                    type="number"
                    value={safeValue('edad')}
                    onChange={onChange}
                    error={!!safeError('edad')}
                    helperText={safeError('edad')}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    select
                    fullWidth
                    label="Identidad de género"
                    name="identidad_genero"
                    value={safeValue('identidad_genero')}
                    onChange={onChange}
                    error={!!safeError('identidad_genero')}
                    helperText={safeError('identidad_genero')}
                >
                    {identidadGenero.map((opcion) => (
                        <MenuItem key={opcion.value} value={opcion.label}>
                        {opcion.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Teléfono / Medio de contacto"
                    name="contacto"
                    value={safeValue('contacto')}
                    onChange={onChange}
                    error={!!safeError('contacto')}
                    helperText={safeError('contacto')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Correo electrónico"
                    name="correo"
                    value={safeValue('correo')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    select
                    fullWidth
                    label="¿La persona afectada ha expresado su voluntad de participar en una medida restaurativa?"
                    name="voluntad_restaurativa"
                    value={safeValue('voluntad_restaurativa')}
                    onChange={onChange}
                    error={!!safeError('voluntad_restaurativa')}
                    helperText={safeError('voluntad_restaurativa')}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                    <MenuItem value="PROCESO">Aún en proceso de decisión</MenuItem>
                </TextField>
            </Grid>

            {mostrarRestoDelFormato && (
                <>
                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="¿Le fue emitida medida de protección?"
                            name="medida_proteccion"
                            value={safeValue('medida_proteccion')}
                            onChange={onChange}
                            error={!!safeError('medida_proteccion')}
                            helperText={safeError('medida_proteccion')}
                        >
                            <MenuItem value="SI">Sí (Adjuntar)</MenuItem>
                            <MenuItem value="NO">No</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="¿Cuenta con acompañamiento psicosocial activo?"
                            name="acompanamiento_psico"
                            value={safeValue('acompanamiento_psico')}
                            onChange={onChange}
                            error={!!safeError('acompanamiento_psico')}
                            helperText={safeError('acompanamiento_psico')}
                        >
                            <MenuItem value="SI">Sí</MenuItem>
                            <MenuItem value="NO">No</MenuItem>
                            <MenuItem value="NO_DESEA">No lo deseo</MenuItem>
                        </TextField>
                    </Grid>
                </>
            )}
        </Grid>
    );
}

/* =======================
    STEP 2 — Objetivos y Propuestas
   ======================= */
function ObjetivosMedidas({ state, onChange }) {
    const max_medidas = 10;

    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');

    const handleCheck = (name, e) => {
        onChange({ target: { name, value: e.target.checked } });
    };

    const handleAddMedida = () => {
        const currentMedidas = state?.medidas_restaurativas?.valor || [];
        if (currentMedidas.length >= max_medidas) return;
        const newMedidas = [...currentMedidas, {
            descripcion: '',
            responsable: '',
            fecha: '',
            seguimiento: ''
        }];
        onChange({ target: { name: 'medidas_restaurativas', value: newMedidas } });
    };

    const handleRemoveMedida = (index) => {
        const currentMedidas = state?.medidas_restaurativas?.valor || [];
        const newMedidas = currentMedidas.filter((_, i) => i !== index);
        onChange({ target: { name: 'medidas_restaurativas', value: newMedidas } });
    };

    const handleMedidaChange = (index, field, value) => {
        const currentMedidas = state?.medidas_restaurativas?.valor || [];
        const newMedidas = [...currentMedidas];
        newMedidas[index] = { ...newMedidas[index], [field]: value };
        onChange({ target: { name: 'medidas_restaurativas', value: newMedidas } });
    };

    const medidas = state?.medidas_restaurativas?.valor || [];
    const errorObjetivos = safeError('objetivos_intervencion');
    const errorMedidas = safeError('medidas_restaurativas');

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Typography variant="subtitle2" color="primary">Objetivos de la Intervención (Seleccione los que apliquen):</Typography>
            </Grid>

            {[
                { label: 'Reconocimiento del daño por la persona que agrede', name: 'obj_reconocimiento' },
                { label: 'Reparación simbólica', name: 'obj_reparacion' },
                { label: 'Acuerdo para no repetición', name: 'obj_norepeticion' },
                { label: 'Restablecimiento de vínculos', name: 'obj_vinculos' },
                { label: 'Participación en espacios comunitarios/cursos', name: 'obj_comunitario' }
            ].map((obj) => (
                <Grid item xs={12} md={6} key={obj.name} style={{ paddingTop: 0, paddingBottom: 0 }}>
                    <FormControlLabel
                        control={<Checkbox checked={!!state?.[obj.name]?.valor} onChange={(e) => handleCheck(obj.name, e)} color="primary" />}
                        label={obj.label}
                    />
                </Grid>
            ))}

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Otros objetivos / Observaciones"
                    name="otros_objetivos"
                    value={safeValue('otros_objetivos')}
                    onChange={onChange}
                    error={!!safeError('otros_objetivos')}
                    helperText={safeError('otros_objetivos')}
                />
            </Grid>

            {!!errorObjetivos && (
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <FormHelperText error>{errorObjetivos}</FormHelperText>
                </Grid>
            )}

            <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                    Medidas Restaurativas Propuestas
                </Typography>
                
                {medidas.map((medida, index) => (
                    <Paper key={index} style={{ padding: 16, marginBottom: 16, backgroundColor: '#f9f9f9' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Descripción de la medida"
                                    value={medida.descripcion || ''}
                                    onChange={(e) => handleMedidaChange(index, 'descripcion', e.target.value)}
                                    error={!!safeError(`medida_${index}_descripcion`)}
                                    helperText={safeError(`medida_${index}_descripcion`)}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Responsable"
                                    value={medida.responsable || ''}
                                    onChange={(e) => handleMedidaChange(index, 'responsable', e.target.value)}
                                    error={!!safeError(`medida_${index}_responsable`)}
                                    helperText={safeError(`medida_${index}_responsable`)}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Fecha"
                                    InputLabelProps={{ shrink: true }}
                                    value={medida.fecha || ''}
                                    onChange={(e) => handleMedidaChange(index, 'fecha', e.target.value)}
                                    error={!!safeError(`medida_${index}_fecha`)}
                                    helperText={safeError(`medida_${index}_fecha`)}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <TextField
                                    fullWidth
                                    label="Seguimiento"
                                    value={medida.seguimiento || ''}
                                    onChange={(e) => handleMedidaChange(index, 'seguimiento', e.target.value)}
                                    error={!!safeError(`medida_${index}_seguimiento`)}
                                    helperText={safeError(`medida_${index}_seguimiento`)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <IconButton onClick={() => handleRemoveMedida(index)} color="secondary">
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Paper>
                ))}
                
                <Button 
                    variant="outlined" 
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleAddMedida}
                    disabled={medidas.length >= max_medidas}
                >
                    Agregar Medida
                </Button>

                {medidas.length >= max_medidas && (
                    <FormHelperText>
                        Máximo permitido: {max_medidas} medidas restaurativas propuestas.
                    </FormHelperText>
                )}

                {!!errorMedidas && (
                    <FormHelperText error>{errorMedidas}</FormHelperText>
                )}
            </Grid>
        </Grid>
    );
}

/* =======================
    STEP 3 — Evaluación y Cierre
   ======================= */
function EvaluacionCierre({ state, onChange }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const theme = useTheme(); 

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Evaluación: Observaciones importantes para el proceso"
                    variant="outlined"
                    name="observaciones_evaluacion"
                    value={safeValue('observaciones_evaluacion')}
                    onChange={onChange}
                    error={!!safeError('observaciones_evaluacion')}
                    helperText={safeError('observaciones_evaluacion')}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        <strong>CONSENTIMIENTO:</strong> Yo, {safeValue('nombre_afectado')}, manifiesto que he sido informada sobre el alcance del proceso restaurativo. Participo de manera libre, voluntaria y consciente de que puedo desistir en cualquier momento.
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
}

export const Formulario007Steps = [
    {
        label: 'Identificación',
        render: (props) => <IdentificacionDecision {...props} />
    },
    {
        label: 'Plan Restaurativo',
        render: (props) => <ObjetivosMedidas {...props} />
    },
    {
        label: 'Cierre y Consentimiento',
        render: (props) => <EvaluacionCierre {...props} />
    }
];